import React, { useCallback } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import strings from 'strings';
import AutocompleteSelect from 'UI/components/molecules/AutocompleteSelect';
import { idOptionSelected, REQUIRED_VALIDATION } from 'UI/utils';
import { OptionRenderers } from 'UI/utils/renderers';

import { FORM_FIELDS_MAP } from '../../drawers/CreateSendoutDrawer/SendoutForm/SendoutForm.constants';

export const AccountableRecruiterSelector = ({ options = [] }) => {
  const { control, errors } = useFormContext();

  const handleOnChange = useCallback(([, value]) => value, []);

  return (
    <Grid item xs={12}>
      <Box display="flex" flexDirection="column" mb={2}>
        <Typography variant="subtitle1">
          {strings.sendoutsV2.form.sections.accountableSelector.title}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {strings.sendoutsV2.form.sections.accountableSelector.subtitle}
        </Typography>
      </Box>

      <Controller
        name={FORM_FIELDS_MAP.AccountableRecruiter.key}
        control={control}
        rules={REQUIRED_VALIDATION}
        defaultValue={null}
        as={
          <AutocompleteSelect
            name={FORM_FIELDS_MAP.AccountableRecruiter.key}
            error={!!errors[FORM_FIELDS_MAP.AccountableRecruiter.key]}
            errorText={errors[FORM_FIELDS_MAP.AccountableRecruiter.key]?.message}
            placeholder={strings.sendouts.form.labels.accountableRecruiter}
            renderOption={OptionRenderers.globalSearchDefault('fullName')}
            getOptionSelected={idOptionSelected}
            displayKey="fullName"
            defaultOptions={options}
          />
        }
        onChange={handleOnChange}
        onChangeName="onSelect"
        valueName="selectedValue"
      />
    </Grid>
  );
};
